<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<ul class="enq_lst_cards column_left">
  @for (vm of auctionViewModels(); track vm.auction.id; let index = $index) {
    <li
      class="relative blink border_overlay"
      [class.ImmediateCutout]="auctionTypeInput() === 'immediate'"
      [style.--text-mask]="vm.textMask">
      <p (click)="goToEnquiry(vm.auction)">
        <bdi> #{{ vm.auction.token }} </bdi>
      </p>

      @if (vm.auction.is_higher_price === true) {
        <div class="profit">
          <h6 class="profitably">
            {{ 'profitably' | translate }}
            <img src="{{ assetsConst.profitybilityIcon }}" alt="img" />
          </h6>
        </div>
      }

      <!-- Header row: countdown / driver info + status label -->
      <h4>
        @if (vm.showCountdownTimer) {
          @if (vm.showImmediateCountdown) {
            <logibids-countdown
              [start]="vm.currentDateTime"
              [end]="vm.auction.schedule_start"
              (timerDone)="timerDone($event, index)">
            </logibids-countdown>
          } @else {
            <span></span>
          }
        } @else {
          @if (vm.showDriverDetails) {
            <div class="driver_detail">
              <div class="lts">
                <figure>
                  <img
                    [src]="
                      vm.auction.driver_details.photo || assetsConst.account
                    "
                    alt="driver photo" />
                </figure>
                <h5>
                  {{ vm.auction.driver_details.name }}
                  @if (vm.auction.driver_details.ratings !== null) {
                    <span class="d_block driver-rating">
                      <i class="pi pi-star-fill"></i>
                      {{
                        vm.auction.driver_details.ratings | truncateDecimal: 1
                      }}
                    </span>
                  }
                </h5>
              </div>
            </div>
          } @else {
            <div class="driver_detail"></div>
          }
        }
        <span>{{ vm.statusLabel }}</span>
      </h4>

      <!-- Vehicle image + price block -->
      <div class="mdl" (click)="goToEnquiry(vm.auction)">
        <figure>
          <img
            [src]="vm.vehicleImage || assetsConst.noVehicle"
            alt="vehicle"
            [class.vehicle-fallback-image]="
              !vm.vehicleImage || vm.vehicleImage === assetsConst.noVehicle
            "
            (error)="onVehicleImageError($event)" />
          <figcaption>
            <p>{{ vm.auction.sub_category_name }}</p>
            @if (vm.auction.locations.length - 1 > 0) {
              @if (
                vm.auction.schedule_type === 'IMMEDIATE' &&
                vm.auction.ride_type === 'SHARED'
              ) {
                <span class="d_block">
                  <b>{{ vm.auction.seats_filled }}</b
                  >/{{ vm.auction.max_seats }}
                  {{ 'seatBooked' | translate }}
                </span>
              } @else {
                <span class="d_block">
                  {{ vm.auction.locations.length - 1 }}
                  {{
                    vm.auction.locations.length === 2
                      ? ('drop' | translate)
                      : ('drops' | translate)
                  }}
                </span>
              }
            }
          </figcaption>
        </figure>

        <!-- Price: Delivery / Immediate trips -->
        @if (vm.showDeliveryImmediatePrice) {
          <h5 [class.schedule]="vm.auction.schedule_type !== 'IMMEDIATE'">
            @if (
              vm.auction.ride_type === 'SHARED' &&
              vm.auction.private_ride_fare !== null &&
              (vm.canShowEarnings || userProfileInput()?.type !== 'DRIVER')
            ) {
              <a class="text_delete">{{ vm.auction.private_ride_fare }}</a>
            }
            @if (vm.isAmountValid) {
              @if (vm.canShowEarnings) {
                @if (
                  vm.auction.module_id === 'TRANSPORT' &&
                  vm.auction.schedule_type === 'IMMEDIATE'
                ) {
                  {{ vm.auction.totalAmountImmediate | number: '1.3-3' }}
                } @else {
                  {{ vm.auction.amount }}
                }
                <sub class="currency-dark">{{ vm.auction.userCurrency }}</sub>
              }
              @if (vm.auction.schedule_type === 'IMMEDIATE') {
                @if (vm.auction.ride_type === 'SHARED') {
                  <span class="ride-sharing-badge">{{
                    'rideSharing' | translate
                  }}</span>
                } @else {
                  <span class="scheduleType_card">{{
                    'Immediate' | translate
                  }}</span>
                }
              } @else {
                @if (vm.canShowEarnings) {
                  <span class="bidAmount_card">{{
                    'bidAmount' | translate
                  }}</span>
                }
              }
              @if (vm.canShowEarnings && vm.auction.sp_cost.tax_amount !== 0) {
                <span class="tax-info">{{ 'taxIncluded' | translate }}</span>
              }
            }
          </h5>
        }

        <!-- Price: Scheduled trips (expired or won) -->
        @if (vm.showSchedulePrice) {
          <h5 [class.schedule]="vm.auction.schedule_type !== 'IMMEDIATE'">
            @if (
              vm.auction.ride_type === 'SHARED' &&
              vm.auction.private_ride_fare !== null
            ) {
              <a class="text_delete">{{ vm.auction.private_ride_fare }}</a>
            }
            @if (vm.isAmountValid) {
              @if (vm.canShowEarnings) {
                {{ vm.auction.amount }}
                <sub class="currency-dark">{{ vm.auction.userCurrency }}</sub>
              }
              @if (vm.auction.schedule_type === 'IMMEDIATE') {
                @if (vm.auction.ride_type === 'SHARED') {
                  <span class="ride-sharing-badge">{{
                    'rideSharing' | translate
                  }}</span>
                } @else {
                  <span class="scheduleType_card">{{
                    'Immediate' | translate
                  }}</span>
                }
              } @else {
                @if (vm.canShowEarnings) {
                  <span class="bidAmount_card">{{
                    'bidAmount' | translate
                  }}</span>
                }
              }
              @if (vm.canShowEarnings && vm.auction.sp_cost.tax_amount !== 0) {
                <span class="tax-info">{{ 'taxIncluded' | translate }}</span>
              }
            }
          </h5>
        }
      </div>

      <!-- Module name cutout watermark -->
      <h3 class="cutout-h3">
        <span class="cutout-text" [attr.data-index]="index" #cutoutText>
          {{ vm.auction.module_name }}
        </span>
      </h3>

      <!-- Pickup / Drop-off: TRANSPORT SCHEDULE -->
      @if (
        vm.auction.module_id === 'TRANSPORT' &&
        vm.auction.schedule_type !== 'IMMEDIATE'
      ) {
        <div
          class="loc_point"
          (click)="goToEnquiry(vm.auction)"
          [style.border-bottom]="
            vm.auction.locations.length > 2 ? 'none' : null
          ">
          <ul [class.heightfull]="vm.auction.isActiveHeight">
            @for (list of vm.auction.locations; track list.id; let j = $index) {
              @if (j < 2) {
                <li
                  [style.--flagImg]="'url(' + list.flag + ')'"
                  [class.schedule]="vm.auction.schedule_type === 'SCHEDULE'"
                  [class.moreIsTrue]="
                    vm.auction.locations.length === 2 ||
                    (vm.auction.locations.length > 2 &&
                      vm.auction.isActiveHeight &&
                      j === 0) ||
                    !vm.auction.isActiveHeight
                  ">
                  <p>
                    {{
                      j === 0 ? ('Pickup' | translate) : ('DropOff' | translate)
                    }}
                    @if (list.neighborhood) {
                      <span class="d_block"
                        >{{ list.neighborhood }}, {{ list.block ?? '' }}</span
                      >
                    } @else if (list.area) {
                      <span class="d_block"
                        >{{ list.state }}, {{ list.area }}</span
                      >
                    }
                  </p>
                  <h6>
                    <bdi>
                      {{ vm.arrayDates[j].date }}
                    </bdi>
                    <span class="d_block">
                      <bdi>
                        {{ vm.arrayDates[j].time }}
                      </bdi>
                    </span>
                  </h6>
                </li>
              }
            }
          </ul>
        </div>
      }

      <!-- Bid blinker overlay (schedule auctions in RUNNING state) -->
      @if (
        vm.auction.status === 'RUNNING' &&
        vm.auction.auction_expired === false &&
        isBlinking() &&
        !vm.auction.stopBlinker &&
        vm.auction.last_bid &&
        vm.auction.schedule_type !== 'IMMEDIATE' &&
        vm.auction.module_id !== 'DELIVERY'
      ) {
        <div
          (click)="goToEnquiry(vm.auction)"
          class="overlay"
          [class.green]="vm.isMyBid"
          [class.red]="vm.isLostBid">
          <h5 logibidsFitText [fitInset]="12" [fitMin]="16" [fitMax]="48">
            {{ vm.auctionOverlayStatus | translate }}
          </h5>
        </div>
      }

      <!-- Pickup / Drop-off: RENTAL -->
      @if (vm.auction.module_id === 'RENTAL') {
        <div class="scrollMdl">
          @if (vm.auction.locations?.length > 0) {
            @for (list of vm.auction.locations; track list.id; let j = $index) {
              <div
                class="mdl btm"
                [style.border-bottom]="
                  vm.auction.locations.length > 2 ? 'none' : null
                ">
                <figure class="figcaption-top">
                  <img
                    [ngSrc]="list.flag"
                    width="100"
                    height="100"
                    alt="location flag"
                    priority />
                  <figcaption>
                    {{ 'LocationAddress' | translate }}
                    @if (list.area || list.neighborhood) {
                      <span class="d_block">{{ list.address }}</span>
                    }
                  </figcaption>
                </figure>
                @if (j === 0) {
                  <h5>
                    <bdi>
                      {{ vm.arrayDates[j].date }}
                    </bdi>
                    <span class="d_block">
                      <bdi>
                        {{ vm.arrayDates[j].time }}
                      </bdi>
                    </span>
                  </h5>
                }
              </div>
              <div class="mdl btm rental-spacer"></div>
            }
          }
        </div>
      }

      <!-- Pickup / Drop-off: DELIVERY / IMMEDIATE -->
      @if (
        vm.auction.module_id === 'DELIVERY' ||
        vm.auction.schedule_type === 'IMMEDIATE'
      ) {
        <div
          class="mdl loc_point"
          (click)="goToEnquiry(vm.auction)"
          [style.border-bottom]="
            vm.auction.locations.length > 2 ? 'none' : null
          ">
          <ul [class.heightfull]="vm.auction.isActiveHeight">
            @for (list of vm.auction.locations; track list.id; let j = $index) {
              @if (j < 2) {
                <li
                  [style.--flagImg]="'url(' + list.flag + ')'"
                  [class.schedule]="vm.auction.schedule_type === 'SCHEDULE'"
                  [class.moreIsTrue]="
                    vm.auction.locations.length === 2 ||
                    (vm.auction.locations.length > 2 &&
                      vm.auction.isActiveHeight &&
                      j === 0) ||
                    !vm.auction.isActiveHeight
                  ">
                  <p>
                    {{
                      j === 0 ? ('Pickup' | translate) : ('DropOff' | translate)
                    }}
                    @if (j > 0 && vm.auction.locations.length > 2) {
                      {{ j }}
                    }
                    @if (list.neighborhood) {
                      <span class="d_block"
                        >{{ list.neighborhood }}, {{ list.block ?? '' }}</span
                      >
                    } @else if (list.area) {
                      <span class="d_block"
                        >{{ list.state }}, {{ list.area }}</span
                      >
                    }
                  </p>
                  <h6>
                    <bdi>
                      {{ vm.arrayDates[j].date }}
                    </bdi>
                    <span class="d_block">
                      <bdi>
                        {{ vm.arrayDates[j].time }}
                      </bdi>
                    </span>
                  </h6>
                </li>
              }
            }
          </ul>
        </div>
      }

      <!-- Distance -->
      <div class="distance">
        <h6>
          {{ 'TotalTripDistance' | translate }}
          {{ vm.auction.distance_km || ('na' | translate) }}
          @if (vm.auction.distance_km) {
            {{ 'KM' | translate }}
          }
        </h6>
      </div>

      <!-- Bid input group (Schedule auctions only) -->
      @if (
        vm.auction.category_reference_id !== 'DELIVERY' &&
        vm.auction.schedule_type !== 'IMMEDIATE' &&
        vm.auction.stopBlinker === false
      ) {
        <div
          class="bid_group"
          [class.disabledDirectBidAuctions]="vm.isDirectBidDisabled">
          @if (
            vm.auction.status === 'RUNNING' &&
            vm.auction.auction_expired === false
          ) {
            <div class="lt">
              @if (vm.showLastBidLabel) {
                <sup>
                  {{ 'LastBid' | translate }}
                  {{ vm.auction.getLastBidTotalTax | number: '1.3-3' }}
                </sup>
              }
              <div class="input_wrapper">
                <input
                  type="text"
                  logibidsNumberMask
                  [decimalLimit]="3"
                  [fixedDecimal]="true"
                  (ngModelChange)="onBidChange($event, vm.auction)"
                  [(ngModel)]="vm.auction.showBidAmount"
                  [placeholder]="
                    vm.auction.isShowBidPlaceholder ? ('noBid' | translate) : ''
                  "
                  [style.margin-left.px]="
                    vm.auction.isShowBidPlaceholder ? 0 : 21
                  " />
                @if (!vm.auction.isShowBidPlaceholder) {
                  <sub>{{ vm.auction.userCurrency }}</sub>
                } @else {
                  <span></span>
                }
              </div>
              @if (vm.auction.sp_cost.tax_amount !== 0) {
                <span class="tax_include">{{ 'taxIncluded' | translate }}</span>
              }
            </div>
          }

          @if (
            vm.auction.status === 'RUNNING' &&
            vm.showImmediateCountdown &&
            vm.auction.auction_expired === false
          ) {
            <div class="rt">
              <p>
                <logibids-countdown
                  [start]="vm.auction.auction_start"
                  [end]="vm.auction.auction_end"
                  (timerDone)="timerDone($event, index)">
                </logibids-countdown>
                <span class="d_block">{{ 'TimeRemaining' | translate }}</span>
              </p>
              <h3 (click)="bidNow(vm.auction.bid_amount, vm.auction)">
                {{ 'BID' | translate }}
              </h3>
            </div>
          }
        </div>

        <!-- Accept button (Delivery / Immediate trips) -->
      } @else if (
        vm.auction.category_reference_id === 'DELIVERY' ||
        vm.auction.schedule_type === 'IMMEDIATE'
      ) {
        @if (
          vm.resolvedStatus === 'RUNNING' ||
          (vm.resolvedStatus === 'ENDED' && vm.auction.bid_status === 'PENDING')
        ) {
          <div class="btn_full btn_accept">
            <p-button
              class="btn primary"
              (click)="acceptDelivery(vm.auction)"
              type="submit"
              label="{{ 'accept' | translate }}" />

            @if (showSkipButton()) {
              <p-button
                class="btn skip_btn"
                (click)="skipNow()"
                type="button"
                [label]="'skip' | translate" />
            }
          </div>
        }
      }

      <!-- Rating overlay -->
      @if (
        vm.auction.trip_status === 'ENDED' &&
        vm.auction.ratings !== null &&
        vm.auction.ratings?.id
      ) {
        <div class="overlay_review" (click)="goToEnquiry(vm.auction)">
          @switch (vm.auction.ratings?.rating) {
            @case (1) {
              <figure>
                <img [src]="assetsConst.emoji_1" alt="bad rating" />
                <figcaption>
                  <img [src]="assetsConst.rating_1" alt="bad rating badge" />
                  {{ 'BAD_EXPERIENCE' | translate }}
                </figcaption>
              </figure>
            }
            @case (2) {
              <figure>
                <img [src]="assetsConst.emoji_2" alt="below average rating" />
                <figcaption>
                  <img [src]="assetsConst.rating_2" alt="below average badge" />
                  {{ 'belowAverage' | translate }}
                </figcaption>
              </figure>
            }
            @case (3) {
              <figure>
                <img [src]="assetsConst.emoji_3" alt="average rating" />
                <figcaption>
                  <img [src]="assetsConst.rating_3" alt="average badge" />
                  {{ 'Average' | translate }}
                </figcaption>
              </figure>
            }
            @case (4) {
              <figure>
                <img [src]="assetsConst.emoji_4" alt="good rating" />
                <figcaption>
                  <img [src]="assetsConst.rating_4" alt="good badge" />
                  {{ 'Good' | translate }}
                </figcaption>
              </figure>
            }
            @case (5) {
              <figure>
                <img [src]="assetsConst.emoji_4" alt="excellent rating" />
                <figcaption>
                  <img [src]="assetsConst.rating_5" alt="excellent badge" />
                  {{ 'Excellent' | translate }}
                </figcaption>
              </figure>
            }
          }
        </div>
      }
    </li>
  }
</ul>
